<template>
  <svg
    id="Component_23_1"
    data-name="Component 23 – 1"
    xmlns="http://www.w3.org/2000/svg"
    width="20.249"
    height="25.607"
    viewBox="0 0 20.249 25.607"
  >
    <path
      id="Path_1"
      data-name="Path 1"
      d="M418.256,1447.032a3.806,3.806,0,0,1-7.317,0Z"
      transform="translate(-404.451 -1424.184)"
      fill="black"
    />
    <path
      id="Path_2"
      data-name="Path 2"
      d="M.068,19.972A5.983,5.983,0,0,1,1.6,16.785c1.433-1.574,1.279-3.831,1.33-5.865.028-1.088-.544-6.771,4.958-8.464,0,0-.057-2.438,2.238-2.454,2.3.016,2.238,2.454,2.238,2.454,5.5,1.693,4.93,7.376,4.958,8.464.052,2.034-.1,4.291,1.33,5.865a5.983,5.983,0,0,1,1.53,3.187,6.938,6.938,0,0,1,.068.824.767.767,0,0,1-.766.793H.766A.767.767,0,0,1,0,20.8a6.939,6.939,0,0,1,.068-.824"
      transform="translate(0 -0.002)"
      fill="black"
    />
    <rect
      id="Rectangle_52"
      data-name="Rectangle 52"
      width="20.249"
      height="25.603"
      transform="translate(0 0.004)"
      fill="none"
    />
  </svg>
</template>

<script setup lang="ts">
import IconProps from '@/assets/ts/interfaces/IconProps'

withDefaults( defineProps<IconProps>(), {} )
</script>

<style scoped></style>
